export const NoAuthUrls = [
    "/login",
    "/auth0-login",
    "/generic-redirect-callback",
    "/resetpassword",
    "/statuscode404",
    "/statuscode401",
    "/approval-page",
    "/add-rightship-inspection",
    "/register",
    "/email-verification",
    "/pdf-download-link"
]
